<span class="app-btn-content" [ngStyle]="{'visibility': isLoading ? 'hidden' : ''}">
    <ng-content></ng-content>
</span>
<span class="app-btn-loader" *ngIf="isLoading">
    <app-spinner></app-spinner>
</span>
